import { gql } from "@apollo/client";

export const DAILY_CHECK_IN_DATA = gql`
  query getDailyCheckIn {
    getDailyCheckIn {
    articleId,
    header,
    description,
    link,
    isActive,
    }
  }
`;


